import { HttpParams } from '@angular/common/http';

import { StringUtils } from '../../../../utils/string.utils';

import { PaginationArgsInterface } from './pagination-args.interface';
import { PaginationArgsBase } from './pagination-args-base.model';

export class PaginationArgs extends PaginationArgsBase {
	orderBy?: string;
	select?: string;
	where?: string;

	constructor({
		limit,
		orderBy,
		page,
		select,
		where,
	}: PaginationArgsInterface) {
		super({ limit, page });
		this.orderBy = StringUtils.convertToString(orderBy);
		this.select = StringUtils.convertToString(select);
		this.where = StringUtils.convertToString(where);
	}

	/**
	 * Constrói uma instância de `HttpParams` com base nos argumentos fornecidos.
	 *
	 * Este método aceita um objeto `PaginationArgs` e adiciona ao `HttpParams`
	 * apenas os valores que não são `undefined`. Isso garante que apenas os parâmetros
	 * definidos sejam enviados na requisição HTTP.
	 *
	 * @returns Uma instância de `HttpParams` com os parâmetros definidos.
	 */
	buildHttpParams(): HttpParams {
		let params = new HttpParams();

		if (this.select !== undefined) {
			params = params.set('select', this.select);
		}

		if (this.where !== undefined) {
			params = params.set('where', this.where);
		}

		if (this.orderBy !== undefined) {
			params = params.set('orderBy', this.orderBy);
		}

		if (this.page !== undefined) {
			params = params.set('page', this.page);
		}

		if (this.limit !== undefined) {
			params = params.set('limit', this.limit);
		}

		return params;
	}
}
